import DayJsUtils from "@date-io/dayjs";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import AlertProvider from "components/common/Alert";
import Loading from "components/common/Loading";
import { envInstants } from "libs/configs/env";
import theme from "libs/configs/theme";
import AdminModalLoadingProvider from "libs/context/AdminModalLoadingContext";
import ModalLoadingProvider from "libs/context/ModalLoadingContext";
import httpClientInstants from "libs/utils/HttpClient";
import { Suspense, useEffect, useState } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "redux/store";
import Router from "Router";

function App() {
  const [isInitEnvError, setInitEnvError] = useState(false);
  const [isInitEnv, setInitEnv] = useState(false);

  useEffect(() => {
    const loadEnv = async () => {
      try {
        await envInstants.init();
        httpClientInstants.setBaseUrl(envInstants.getConfig().baseUrl);
      } catch (error) {
        setInitEnvError(true);
      } finally {
        setInitEnv(true);
      }
    };

    loadEnv();
  }, []);

  if (!isInitEnv) return "";
  if (isInitEnvError) return "Cannot load env !!!";

  return (
    <Suspense fallback="">
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DayJsUtils}>
              <AdminModalLoadingProvider>
                <ModalLoadingProvider>
                  <AlertProvider>
                    <Router />
                  </AlertProvider>
                </ModalLoadingProvider>
              </AdminModalLoadingProvider>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </Suspense>
  );
}

export default App;
